import DataViewer from './data-viewer'

export default DataViewer;